import script from "./MobileAppInstallLink.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileAppInstallLink.vue?vue&type=script&setup=true&lang=js"

import "./MobileAppInstallLink.vue?vue&type=style&index=0&id=283e3c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-283e3c6c"]])

export default __exports__